var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleBed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1036_9207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1036_9207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78043 17.1283C5.78043 15.0379 5.60831 12.9612 5.82174 10.9245C6.11917 8.0965 8.7396 5.79693 11.59 5.76528C17.1889 5.70197 22.7891 5.69372 28.388 5.76665C31.5564 5.80794 34.203 8.57954 34.2678 11.7433C34.3049 13.5282 34.2746 15.3145 34.2746 17.1434H31.522C31.522 16.8696 31.5303 16.6232 31.522 16.3783C31.4752 15.1053 30.5278 14.0691 29.2693 14.0443C27.1363 14.003 25.0006 14.003 22.8662 14.0443C21.6352 14.0677 20.6851 15.0874 20.6272 16.3177C20.6148 16.5682 20.6258 16.8186 20.6258 17.1269H19.0822C19.0629 16.8255 19.0533 16.531 19.0258 16.2379C18.9115 14.9883 17.9682 14.0553 16.7138 14.0374C14.6263 14.0085 12.5374 14.0071 10.4485 14.0374C9.18437 14.0567 8.21358 15.0461 8.12546 16.3163C8.10756 16.5668 8.1227 16.8186 8.1227 17.1269H5.78181L5.78043 17.1283ZM20.0062 8.241V8.24375C17.299 8.24375 14.5918 8.22173 11.886 8.25063C9.95686 8.27128 8.32374 9.84286 8.23424 11.6855C8.21634 12.0654 8.19293 12.4727 8.70793 12.5167C9.2064 12.5594 9.28351 12.1878 9.33171 11.7929C9.51485 10.297 10.5572 9.34469 12.0623 9.34193C17.3389 9.3323 22.6142 9.33368 27.8909 9.34193C29.3973 9.34469 30.4617 10.2791 30.6614 11.7626C30.7179 12.1837 30.7674 12.5938 31.3127 12.5071C31.8442 12.4232 31.8015 11.9773 31.7492 11.581C31.4972 9.65295 29.9454 8.25889 27.99 8.24513C25.3297 8.22724 22.6679 8.241 20.0076 8.241H20.0062Z",
    fill: "url(#paint0_linear_1036_9207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87389 24.2866C2.87389 23.3532 2.83105 22.4672 2.88357 21.5884C2.98307 19.9026 4.34577 18.593 6.01805 18.5829C9.28797 18.5643 12.5579 18.5758 15.8264 18.5758C21.7444 18.5758 27.6623 18.5758 33.5788 18.5758C35.9103 18.5758 37.1404 19.8667 37.1431 22.3064C37.1431 22.9497 37.1431 23.5916 37.1431 24.2851H2.87389V24.2866Z",
    fill: "url(#paint1_linear_1036_9207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85742 28.572V25.7148H37.1431V28.572H2.85742Z",
    fill: "url(#paint2_linear_1036_9207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9704 17.1424H22.9304C22.6742 16.1678 23.0892 15.7167 24.2275 15.7157C25.6618 15.7138 27.0961 15.7157 28.5316 15.7157C29.7539 15.7157 30.1144 16.0625 29.9704 17.1434V17.1424Z",
    fill: "url(#paint3_linear_1036_9207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1144 17.1434H10.0427C9.85804 16.1369 10.2658 15.7162 11.4017 15.7153C12.8356 15.7143 14.2682 15.7153 15.7021 15.7153C16.8901 15.7153 17.2548 16.0699 17.1144 17.1434Z",
    fill: "url(#paint4_linear_1036_9207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85742 32.858V28.5723H5.71456C5.4022 30.0347 5.10416 31.4331 4.80039 32.858H2.85742Z",
    fill: "url(#paint5_linear_1036_9207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1996 32.858C34.8929 31.4195 34.5962 30.0327 34.2852 28.5723H37.1423V32.858H35.1996Z",
    fill: "url(#paint6_linear_1036_9207)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1036_9207",
    x1: 20.0006,
    y1: 5.71484,
    x2: 20.0006,
    y2: 17.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1036_9207",
    x1: 20.0003,
    y1: 18.5723,
    x2: 20.0003,
    y2: 24.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1036_9207",
    x1: 20.0003,
    y1: 25.7148,
    x2: 20.0003,
    y2: 28.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1036_9207",
    x1: 26.4289,
    y1: 15.7148,
    x2: 26.4289,
    y2: 17.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1036_9207",
    x1: 13.5714,
    y1: 15.7148,
    x2: 13.5714,
    y2: 17.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1036_9207",
    x1: 4.28599,
    y1: 28.5723,
    x2: 4.28599,
    y2: 32.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1036_9207",
    x1: 35.7137,
    y1: 28.5723,
    x2: 35.7137,
    y2: 32.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBed);
export default __webpack_public_path__ + "static/media/double_bed.7268b21061a538cfc408fd699d8f56c4.svg";
export { ForwardRef as ReactComponent };